var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBentoQrcodeMob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8911 5.83333H9.33333V0.777778C9.33333 0.35 8.98333 0 8.55556 0H5.44444C5.01667 0 4.66667 0.35 4.66667 0.777778V5.83333H3.10163C2.40941 5.83333 2.05941 6.67333 2.54941 7.16333L6.1194 10.5C6.42274 10.8033 7.5622 10.8033 7.86553 10.5L11.4355 7.16333C11.9255 6.67333 11.5833 5.83333 10.8911 5.83333ZM0 13.2222C0 13.65 0.35 14 0.777778 14H13.2222C13.65 14 14 13.65 14 13.2222C14 12.7944 13.65 12.4444 13.2222 12.4444H0.777778C0.35 12.4444 0 12.7944 0 13.2222Z",
    fill: "#858585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBentoQrcodeMob);
export default __webpack_public_path__ + "static/media/bento-qrcode-mob.69c5f20a39f2463e2ab2a039cdc3df62.svg";
export { ForwardRef as ReactComponent };